"use client";

import { useRouter, usePathname } from "next/navigation";
import { useLocale, useTranslations } from "next-intl";
import { Menu } from "@headlessui/react";
import { ArrowDown, Check } from "@/assets/icons/Icons";



export const LanguageSelector = () => {
  const t = useTranslations("Lang");
  const router = useRouter();
  const pathname = usePathname();
  const currentLang = useLocale() as "ru" | "en" | "uz";

  const languages: {
    code: "ru" | "en" | "uz";
    label: string;
    shortLabel: string;
  }[] = [
    { code: "ru", label: "Русский", shortLabel: "Рус" },
    { code: "en", label: "English", shortLabel: "Eng" },
  ];

  const handleLanguageChange = (newLang: "ru" | "en" | "uz") => {
    if (newLang === currentLang) return;
    const newPath = `/${newLang}${pathname.replace(/^\/[a-z]{2}/, "")}`;
    router.push(newPath);
  };

  return (
    <div>
      <Menu
        as="div"
        className="relative hidden lg:flex items-center gap-2 lg:text-xl text-base"
      >
        {({ open }) => (
          <>
            <Menu.Button className="flex items-center gap-2 cursor-pointer">
              {languages.find((lang) => lang.code === currentLang)?.shortLabel}
              {/* Rotate the ArrowDown icon when the menu is open */}
              <div
                className={`transform transition-transform duration-300 ${
                  open ? "rotate-180" : ""
                }`}
              >
                {open ? <ArrowDown/> : <ArrowDown />}
              </div>
            </Menu.Button>

            <Menu.Items
              modal={false}
              className="absolute top-full right-0 mt-2 z-10 border py-[10px] w-[167px] h-[102px] border-[#F5F5F5] rounded-lg overflow-hidden bg-white shadow-md lg:text-xl text-base"
            >
              {languages.map(({ code, label }, index) => (
                <Menu.Item key={code}>
                  {({ active }) => (
                    <button
                      onClick={() => handleLanguageChange(code)}
                      className={`w-full text-left px-3 py-[6px] space-y-[10px] font-semibold text-base border-b border-[#FFFFFF1A] cursor-pointer 
                      ${index === languages.length - 1 ? "border-none" : ""}  
                      ${code === currentLang ? "text-[#E50014]" : ""} 
                      ${
                        active ? "border-b border-[#F5F5F5] bg-[#F5F5F5]" : ""
                      }`}
                    >
                      {label}
                    </button>
                  )}
                </Menu.Item>
              ))}
            </Menu.Items>
          </>
        )}
      </Menu>

      <div className="lg:hidden flex flex-col items-start gap-4 text-lg font-medium mt-2">
        <p className="text-sm font-medium text-[#00000099]">{t("lang")}</p>

        <div className="flex justify-between items-center w-full">
          <button
            onClick={() => handleLanguageChange("en")}
            className={currentLang === "en" ? "text-primary" : ""}
          >
            {t("en")}
          </button>
          {currentLang === "en" && <Check className="w-6 h-6" />}
        </div>

        <div className="flex justify-between items-center w-full">
          <button
            onClick={() => handleLanguageChange("ru")}
            className={currentLang === "ru" ? "text-primary" : ""}
          >
            {t("ru")}
          </button>
          {currentLang === "ru" && <Check className="w-6 h-6" />}
        </div>
      </div>
    </div>
  );
};
